import { render } from "./myPosition.vue?vue&type=template&id=dcdcea70&scoped=true"
import script from "./myPosition.vue?vue&type=script&lang=js"
export * from "./myPosition.vue?vue&type=script&lang=js"

import "./myPosition.vue?vue&type=style&index=0&id=dcdcea70&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/embeddedJobWebProd/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcdcea70"]])

export default __exports__